//import React from 'react';

export default function post(url: string, params = {}, on_load?: any) {

  return fetch(url, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(params)
  }).then((response) => response.json())
    .then((json) => {
      //return json.content;
      if(on_load)
      {
        on_load(json.content);
      }
    })
    .catch((error) => {
      console.error(error);
    });
}